import api from '~/api';
import { EquipmentForm } from '~/models/ModelEquipment';

// 스네이크케이스를 카멜케이스로 변환하여 백엔드 형식에 맞춤
const convertToBackendFormat = (data: EquipmentForm) => {
  const backendData: any = {};
  
  // 모든 필드를 변환 (undefined만 제외, null과 빈 문자열은 포함)
  if (data.eqpmn_id !== undefined) backendData.eqpmnId = data.eqpmn_id;
  if (data.assets_no !== undefined) backendData.assetsNo = data.assets_no;
  if (data.eqpmn_nm_korean !== undefined) backendData.eqpmnNmKorean = data.eqpmn_nm_korean;
  if (data.eqpmn_nm_engl !== undefined) backendData.eqpmnNmEngl = data.eqpmn_nm_engl;
  if (data.model_nm !== undefined) backendData.modelNm = data.model_nm;
  if (data.eqpmn_cl_id !== undefined) backendData.eqpmnClId = data.eqpmn_cl_id;
  if (data.eqpmn_stndrd !== undefined) backendData.eqpmnStndrd = data.eqpmn_stndrd;
  if (data.sumry !== undefined) backendData.sumry = data.sumry;
  if (data.spec_composition !== undefined) backendData.specComposition = data.spec_composition;
  if (data.asstn_mhrls !== undefined) backendData.asstnMhrls = data.asstn_mhrls;
  if (data.realm_prpos !== undefined) backendData.realmPrpos = data.realm_prpos;
  if (data.image_id !== undefined) backendData.imageId = data.image_id;
  if (data.srcelct !== undefined) backendData.srcelct = data.srcelct;
  if (data.mnl_at !== undefined) backendData.mnlAt = data.mnl_at;
  if (data.sw_at !== undefined) backendData.swAt = data.sw_at;
  if (data.legacy_itlpc !== undefined) backendData.legacyItlpc = data.legacy_itlpc;
  if (data.pchrg_at !== undefined) backendData.pchrgAt = data.pchrg_at;
  if (data.spcmnt !== undefined) backendData.spcmnt = data.spcmnt;
  if (data.eqpmn_sttus !== undefined) backendData.eqpmnSttus = data.eqpmn_sttus;
  if (data.as_entrprs_nm !== undefined) backendData.asEntrprsNm = data.as_entrprs_nm;
  if (data.as_charger_nm !== undefined) backendData.asChargerNm = data.as_charger_nm;
  if (data.as_charger_cttpc !== undefined) backendData.asChargerCttpc = data.as_charger_cttpc;
  // purchs_dt: 빈 문자열이 아닐 때만 포함 (이미 YYYY-MM-DD 형식)
  if (data.purchs_dt !== undefined && data.purchs_dt !== null && data.purchs_dt.trim() !== '') {
    backendData.purchsDt = data.purchs_dt.trim();
  }
  if (data.str_nm !== undefined) backendData.strNm = data.str_nm;
  if (data.purchs_pc !== undefined) backendData.purchsPc = data.purchs_pc;
  if (data.makr !== undefined) backendData.makr = data.makr;
  if (data.tkout_at !== undefined) backendData.tkoutAt = data.tkout_at;
  
  // 백엔드 서비스 코드에서 필수로 사용하는 필드들에 기본값 설정
  if (backendData.rntfeeHour === undefined) {
    backendData.rntfeeHour = 0;
  }
  if (backendData.usefulBeginHour === undefined) {
    backendData.usefulBeginHour = 9; // 기본값 9시
  }
  if (backendData.usefulEndHour === undefined) {
    backendData.usefulEndHour = 18; // 기본값 18시
  }
  if (backendData.usefulHour === undefined) {
    backendData.usefulHour = 8; // 기본값 8시간
  }
  if (backendData.useRateInctvSetupAt === undefined) {
    backendData.useRateInctvSetupAt = false;
  }
  if (backendData.hldyInclsAt === undefined) {
    backendData.hldyInclsAt = false;
  }
  if (backendData.tkoutHldyInclsAt === undefined) {
    backendData.tkoutHldyInclsAt = false;
  }
  if (backendData.nttkoutHldyInclsAt === undefined) {
    backendData.nttkoutHldyInclsAt = false;
  }
  // dscntId는 null일 수 있지만, 백엔드 코드에서 for문을 돌리므로 빈 배열로 설정
  if (backendData.dscntId === undefined) {
    backendData.dscntId = [];
  }
  
  return backendData;
};

// 실증장비 등록
export const fetchEquipmentPost = (data: EquipmentForm) => {
  const convertedData = convertToBackendFormat(data);
  return api({
    url: `${process.env.REACT_APP_DOMAIN || ''}/tsp-api/api/admin/eqpmns`,
    method: 'post',
    data: convertedData
  });
};

// 실증장비 목록 조회
export const fetchEquipmentList = (params?: {
  eqpmnSttus?: string;
  assetsNo?: string;
  eqpmnNmKorean?: string;
  modelNm?: string;
  tkoutAt?: boolean;
  disuseAt?: boolean;
  beginDay?: string;
  endDay?: string;
  page?: number;
  itemsPerPage?: number;
}) =>
  api({
    url: `${process.env.REACT_APP_DOMAIN || ''}/tsp-api/api/admin/eqpmns`,
    method: 'get',
    params: params
  });

// 실증장비 상세 조회
export const fetchEquipmentDetail = (eqpmnId: string) =>
  api({
    url: `${process.env.REACT_APP_DOMAIN || ''}/tsp-api/api/admin/eqpmns/mngms/details/${eqpmnId}`,
    method: 'get'
  });

export {};
